import React from 'react';
import { getFormattedDate } from '../../common/date';

export default function DateFormatter({ row, field }) {
	return <div>{getFormattedDate(new Date(row[field]))}</div>;
}
